var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useId } from 'react';
import classNames from 'classnames';
export var RadioBlock = React.forwardRef(function (_a, ref) {
    var checked = _a.checked, children = _a.children, className = _a.className, label = _a.label, labelClass = _a.labelClass, name = _a.name, selectedValue = _a.selectedValue, showChildren = _a.showChildren, value = _a.value, inputProps = __rest(_a, ["checked", "children", "className", "label", "labelClass", "name", "selectedValue", "showChildren", "value"]);
    var id = useId();
    var isSelected = checked || selectedValue === value;
    return (React.createElement("div", { className: classNames('ffe-radio-block', className) },
        React.createElement("input", __assign({ checked: isSelected, className: "ffe-radio-input", id: id, ref: ref, type: "radio", name: name, value: value, "aria-describedby": (children && showChildren) || (children && isSelected)
                ? "".concat(id, "-described")
                : undefined }, inputProps)),
        React.createElement("div", { className: "ffe-radio-block__content" },
            React.createElement("label", { className: classNames('ffe-radio-block__header', labelClass), htmlFor: id }, label),
            (isSelected || showChildren) && (React.createElement("div", { className: classNames('ffe-radio-block__wrapper', {
                    'ffe-radio-block__wrapper--empty': !children,
                }), id: "".concat(id, "-described") }, children)))));
});
